import * as React from "react";
import { connect } from "react-redux";

import { IState } from "../../data/reducers/state";
import { SSTable } from "../common/TableData";

function CompetitionMapTab({ competitions, competitionMap }) {
  const unmappedCompetitions = Object.keys(competitions || {}).filter(
    (v) => competitions[v].isNew,
  ).length;

  return (
    <div>
      <p>
        This import will create
        {unmappedCompetitions} competitions
      </p>

      <SSTable>
        <thead>
          <tr>
            <td>Name</td>
            <td>Binding</td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(competitions || {}).map((v) => (
            <tr
              key={v}
              style={{
                backgroundColor: competitions[v].isNew ? "lightyellow" : "",
              }}
            >
              <td>{competitions[v].name}</td>
              <td style={{ width: "200px" }}>
                <p>
                  {competitionMap[v] ? competitionMap[v].name : "Will create"}
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </SSTable>
    </div>
  );
}

function mapStateToProps(state: IState, props) {
  return {
    competitionMap: state.competitions.map,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(CompetitionMapTab);
